import gql from "graphql-tag";
import { graphql, compose } from "react-apollo";


export const getNotificationCount = gql`
  mutation notificationCount($uid: Int!) {
    notificationCount(uid: $uid) {
      count
    }
  }
`

export const updateNotificationStatus = gql`
  mutation updateNotificationStatus($notifPk: Int!, $status: Int!) {
    updateNotificationStatus(notifPk: $notifPk, status: $status) {
      notif {
        notifPk
      }
    }
  }
`

export const getNotifications = gql`
  query notifications($filterBy: [JSONString], $offset: Int = 0, $pageSize: Int = 10, $sort: [JSONString], $uid: Int = 0) {
    notifications(filterBy: $filterBy, offset: $offset, pageSize: $pageSize, sort: $sort, uid: $uid) {
      notifications {
        notifPk
        title
        message
        getStatus
        getNotifType
        timeSent
        action
      }
      pages
      hasNext
      hasPrev
    }
  }
`


// WEBPACK FOOTER //
// ./src/views/notifications/graph.js